import { Star } from 'lucide-react';

/** Five-star row with fractional fill, so 4.6 reads as 4.6 rather than 5. */
export function Stars({ value, className = 'size-3.5' }: { value: number; className?: string }) {
  const pct = Math.max(0, Math.min(100, (value / 5) * 100));
  const row = (cls: string) => (
    // w-max keeps the row at its natural width; the clip happens on the wrapper,
    // otherwise the filled stars shrink to fit and slide off the grey ones.
    <span className={`flex w-max gap-0.5 ${cls}`}>
      {[1, 2, 3, 4, 5].map((n) => (
        <Star key={n} className={`${className} shrink-0 fill-current`} />
      ))}
    </span>
  );
  return (
    <span className="relative inline-flex shrink-0" aria-label={`${value.toFixed(1)} out of 5`} role="img">
      {row('text-muted-foreground/25')}
      <span className="absolute inset-y-0 left-0 overflow-hidden text-yellow-400" style={{ width: `${pct}%` }} aria-hidden>
        {row('')}
      </span>
    </span>
  );
}
